<template>
  <main>
    <section class="section">
      <div class="container">
        <h1 class="text-center mb-5">{{ clubNews.title }}</h1>
        <div id="news-card" v-if="clubNews">
          <div class="row my-3 justify-content-center">
            <div class="col-8">
              <figure v-if="imageSrc(clubNews)">
                <img class="card-img-top" :src="imageSrc(clubNews)" alt="Card image"/>
              </figure>
            </div>
          </div>
          <div class="row my-3 text-center">
            <div class="col">
              <p>
                {{ clubNews.text }}
              </p>
            </div>
          </div>
        </div>

        <div v-else>
          Lade Daten...
        </div>
      </div>
    </section>
  </main>
</template>

<script>

import { onMounted, ref, computed } from "vue";
import axios from 'axios';
import { useRoute } from 'vue-router'

export default {
  setup() {

    const clubNews = ref([]);

    const route = useRoute();
    const id = route.params.id;

    const fetchData = async() => {
      try {
        const response = await axios.get('http://localhost:8082/gemeinde/news/id/' + id);
        clubNews.value = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    onMounted(() => {
      fetchData()
    })

    // Computed Property für das Bild
    const imageSrc = computed(() => (newsItem) => {
      return newsItem.imageName
          ? 'http://localhost:8082/' + newsItem.imageName.split('/').pop()
          : new URL('@/assets/images/news-placeholder.png', import.meta.url).href;
    });

    return { 
      clubNews,
      imageSrc
    };
  }
}
</script>

<style></style>
